import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BreadcrumbSchemaForm = () => {
  const [breadcrumbs, setBreadcrumbs] = useState([{ name: "", url: "" }]);
  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://example.com/",
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Category",
        "item": "https://example.com/category",
      },
    ],
  });

  const handleBreadcrumbChange = (index, field, value) => {
    const updatedBreadcrumbs = breadcrumbs.map((breadcrumb, i) =>
      i === index ? { ...breadcrumb, [field]: value } : breadcrumb
    );
    setBreadcrumbs(updatedBreadcrumbs);
  };

  const addBreadcrumb = () => {
    setBreadcrumbs([...breadcrumbs, { name: "", url: "" }]);
  };

  const removeBreadcrumb = (index) => {
    setBreadcrumbs(breadcrumbs.filter((_, i) => i !== index));
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": breadcrumbs.map((breadcrumb, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": breadcrumb.name,
        "item": breadcrumb.url,
      })),
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedSchema = generateSchema();
    setSchema(updatedSchema);
    toast.success("Breadcrumb Schema updated successfully!");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
      toast.info("JSON-LD copied to clipboard!");
    });
  };
 const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://example.com/",
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Category",
          "item": "https://example.com/category",
        },
      ],
    });
    toast.warning("Schema reset to dummy data!");
  };

  return (
    <div className="container-fluid mt-5">
      <ToastContainer />
      <h3 className="text-center mb-4">Breadcrumb Schema Generator</h3>
      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter Breadcrumb Details</h5>
            <form onSubmit={handleSubmit}>
              {breadcrumbs.map((breadcrumb, index) => (
                <div key={index} className="row g-3 align-items-center mb-3">
                  <div className="col-md-12">
                    <label className="form-label">Page #{index + 1} Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={breadcrumb.name}
                      onChange={(e) =>
                        handleBreadcrumbChange(index, "name", e.target.value)
                      }
                      placeholder={`Enter name for page #${index + 1}`}
                    />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Page #{index + 1} URL</label>
                    <input
                      type="text"
                      className="form-control"
                      value={breadcrumb.url}
                      onChange={(e) =>
                        handleBreadcrumbChange(index, "url", e.target.value)
                      }
                      placeholder={`Enter URL for page #${index + 1}`}
                    />
                  </div>
                  <div className="col-md-2 text-end">
                    {index > 0 && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeBreadcrumb(index)}
                      >
                        ✖
                      </button>
                    )}
                  </div>
                </div>
              ))}

              <div className="text-center mb-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addBreadcrumb}
                >
                  + Add URL
                </button>
              </div>

              <div className="text-center">
                <button type="submit" className="btn btn-success w-100">
                  Generate Schema
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-lg-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            <div className="bg-light p-3 rounded border">
              <JSONPretty id="json-pretty" data={schema}></JSONPretty>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbSchemaForm;
